module.exports = __webpack_public_path__ + "img/icons-178.11b3dad2.svg";